(function () {
  var KEY = 'pg_quote_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
  }
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  var cache = {};
  function product(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function root() { return document.querySelector('[data-pg-quote-page]'); }

  function render() {
    var el = root();
    if (!el) return;

    var list = read();
    var body = el.querySelector('[data-rows]');
    var empty = el.querySelector('[data-empty]');
    var live = el.querySelector('[data-live]');
    var countEl = el.querySelector('[data-count]');
    var totalEl = el.querySelector('[data-total]');
    var payload = el.querySelector('[data-payload]');

    if (countEl) countEl.textContent = list.length;

    if (!list.length) {
      if (empty) empty.hidden = false;
      if (live) live.hidden = true;
      if (payload) payload.value = '';
      return;
    }
    if (empty) empty.hidden = true;
    if (live) live.hidden = false;

    Promise.all(list.map(function (i) { return product(i.h); })).then(function (data) {
      var total = 0;
      var lines = [];
      body.innerHTML = '';

      data.forEach(function (p, idx) {
        var item = list[idx];
        var title = (p && p.title ? p.title : item.t || item.h).replace('SAMPLE: ', '');
        var price = p && typeof p.price === 'number' ? p.price : 0;
        var url = p && p.url ? p.url : '/products/' + item.h;
        var img = p && p.featured_image ? p.featured_image : null;
        total += price;
        lines.push((idx + 1) + '. ' + title + '  ' + (price ? money(price) : 'price on application') + '  ' + location.origin + url);

        var row = document.createElement('div');
        row.className = 'qrow';
        row.innerHTML =
          '<a class="qthumb" href="' + url + '">' +
            (img ? '<img src="' + img.replace(/(\.[a-z]+)(\?|$)/i, '_320x$1$2') + '" alt="">' : '<span class="qph"></span>') +
          '</a>' +
          '<div class="qmeta">' +
            '<a class="qtitle" href="' + url + '"></a>' +
            '<p class="qsub"></p>' +
          '</div>' +
          '<div class="qprice">' + (price ? money(price) : 'On application') + '</div>' +
          '<button type="button" class="qdel" aria-label="Remove">Remove</button>';

        row.querySelector('.qtitle').textContent = title;
        var sub = row.querySelector('.qsub');
        if (p && p.type) sub.textContent = p.type; else sub.remove();

        row.querySelector('.qdel').addEventListener('click', function () {
          var cur = read().filter(function (x) { return x.h !== item.h; });
          write(cur);
          document.querySelectorAll('[data-pg-qty]').forEach(function (b) { b.textContent = cur.length; });
          render();
        });

        body.appendChild(row);
      });

      if (totalEl) totalEl.textContent = total ? money(total) : 'On application';
      if (payload) payload.value = lines.join('\n') + '\n\nEquipment subtotal: ' + (total ? money(total) : 'on application') + '\nExcludes freight, surfacing and installation.';
    });
  }

  function init() {
    if (!root()) return;
    render();
    var clear = document.querySelector('[data-clear-quote]');
    if (clear && !clear.dataset.bound) {
      clear.dataset.bound = '1';
      clear.addEventListener('click', function () {
        write([]);
        document.querySelectorAll('[data-pg-qty]').forEach(function (b) { b.textContent = '0'; });
        render();
      });
    }
    if (location.search.indexOf('contact_posted=true') > -1) {
      write([]);
      document.querySelectorAll('[data-pg-qty]').forEach(function (b) { b.textContent = '0'; });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
